import { render, staticRenderFns } from "./SpotPriceBar.vue?vue&type=template&id=98472e98"
import script from "./SpotPriceBar.vue?vue&type=script&lang=js"
export * from "./SpotPriceBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports